import { logError, logTime } from "~/utils/index";
import https from "https";

function isDataFound(data) {
  if (!data) {
    return false;
  }
  if (Array.isArray(data) && data.length === 0) {
    return false;
  }
  if (typeof data === "object" && Object.keys(data).length === 0) {
    return false;
  }

  return true;
}

export async function redisGetHandler(
  redis,
  axios,
  apiPath,
  path,
  reset = false,
) {
  const start = Date.now();
  let url = apiPath + path;
  if (reset) {
    url += `${path.indexOf("?") > -1 ? "&" : "?"}clear_cache=${reset}`;
  }
  if (reset) {
    console.log("redisGetHandler - url", url);
  }
  if (!redis) {
    const { data } = await axios.get(url);
    logTime(start, `reset, ${url}`);
    return data;
  }

  try {
    const [redisKey, ...keyArray] = path.split("/").filter((item) => !!item);
    const key = keyArray.join("/");
    if (!reset) {
      const cachedData = await redis.hget(`Api_${redisKey}`, key);
      if (cachedData) {
        logTime(start, `cache, ${url}`);
        return JSON.parse(cachedData);
      }
    }
    const { data } = await axios.get(url, {
      httpsAgent: new https.Agent({
        rejectUnauthorized: false,
      }),
    });

    if (isDataFound(data)) {
      await redis.hset(`Api_${redisKey}`, key, JSON.stringify(data));
    } else {
      await redis.hdel(`Api_${redisKey}`, key);
    }
    logTime(start, `no cache, ${url}`);
    return data;
  } catch (event) {
    logTime(start, `redis error, ${url}`);
    logError("redisGetHandler error", {
      url,
      path,
      reset,
      error: event,
    });
    const { data } = await axios.get(url);
    return data;
  }
}
